export default __webpack_public_path__ + "static/media/title_zh_tw_sp.2f1eadfe.png";